import { z } from 'zod'

export const SignInSchema = z.object({
  email: z.string().email(),
  password: z.string(),
  CfTurnstileResponse: z.string(),
})

export type TSignInFields = z.infer<typeof SignInSchema>
